
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[package]",
      function () {
        return require("private-next-pages/[package]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[package]"])
      });
    }
  